<mat-form-field class="full-width" [floatLabel]="true">
  <mat-label> {{ 'label.search_by_term' | translate: searchTerm }}</mat-label>
  <input #tableSearchBar data-cy="table_searchbar" [value]="currentSearch$ | async" type="text" matInput />
</mat-form-field>
